import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true, 
});

instance.interceptors.request.use((config) => {
  if(localStorage.getItem('sanctumToken') == null){
    return config;
  }
  const token = atob(decodeURIComponent(JSON.parse(localStorage.getItem('sanctumToken')))) ?? '';
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`; 
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// instance.interceptors.response.use(
//   (response) => response, 
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn("Unauthorized - maybe session expired?");
//       localStorage.removeItem("sanctumToken"); 
//       window.location.href = "/signin";
//     }
//     return Promise.reject(error); 
//   }
// );

export default instance;
